import {VersionVariants} from '@jobseeker/lotus/enums';

import V1 from './V1';
import V2 from './V2';
import {ChipPropsType} from './types';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = V2;

const CTA = (props: ChipPropsType) => {
  let Component;
  if (
    props.versionVariant &&
    Object.keys(componentMap).includes(props.versionVariant)
  ) {
    Component = componentMap[props.versionVariant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default CTA;
